module.exports = __webpack_public_path__ + "img/LB.4a9a0971.png";